<template>
  <!-- Removing something from the world is not undoable, so the button asks
       once before it acts. It asks in place: a native confirm() dialog blocks
       the renderer and cannot be driven during testing. -->
  <span class="entity-remove">
    <template v-if="confirming">
      <button
          :disabled="busy"
          class="remove-step remove-step--yes"
          title="Confirm removal"
          type="button"
          @click.stop="$emit('confirm')"
      >Remove</button>
      <button
          :disabled="busy"
          class="remove-step"
          title="Keep it"
          type="button"
          @click.stop="$emit('cancel')"
      >Keep</button>
    </template>
    <button
        v-else
        :disabled="busy"
        class="remove-trigger"
        title="Remove from the world"
        type="button"
        @click.stop="$emit('request')"
    >
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <path d="M3 4.5h10M6.5 4.5V3h3v1.5M4.5 4.5l.6 8.2h5.8l.6-8.2"/>
      </svg>
    </button>
  </span>
</template>

<script>
export default {
  name: 'EntityRemove',
  props: {
    confirming: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    }
  },
  emits: ['request', 'confirm', 'cancel']
};
</script>

<style scoped>
.entity-remove {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  flex: none;
}

.remove-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--gm-radius-sm);
  color: var(--gm-text-dim);
  cursor: pointer;
  transition: color var(--gm-duration) var(--gm-ease),
              background var(--gm-duration) var(--gm-ease);
}

.remove-trigger:hover:not(:disabled) {
  color: var(--gm-danger);
  background: rgba(201, 69, 63, 0.12);
}

.remove-trigger:focus-visible {
  outline: none;
  border-color: var(--gm-danger);
}

.remove-trigger svg {
  width: 12px;
  height: 12px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.4;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.remove-step {
  padding: 0.16rem 0.36rem;
  font-family: var(--gm-font-body);
  font-size: var(--gm-text-micro);
  letter-spacing: var(--gm-track-label);
  text-transform: uppercase;
  color: var(--gm-text-muted);
  background: var(--gm-surface-sunken);
  border: 1px solid var(--gm-border-dim);
  border-radius: var(--gm-radius-sm);
  cursor: pointer;
  transition: color var(--gm-duration) var(--gm-ease),
              border-color var(--gm-duration) var(--gm-ease);
}

.remove-step:hover:not(:disabled) {
  color: var(--gm-text);
  border-color: var(--gm-border-hi);
}

.remove-step--yes {
  color: var(--gm-danger);
  border-color: var(--gm-danger);
}

.remove-step:disabled {
  cursor: default;
  opacity: 0.55;
}
</style>
